var ProjectConfig = /** @class */ (function () {
    function ProjectConfig(timeStamp, jsonConfig, httpETag) {
        this.Timestamp = timeStamp;
        this.ConfigJSON = JSON.parse(jsonConfig);
        this.HttpETag = httpETag;
    }
    /**
     * Determines whether the specified ProjectConfig instances are considered equal.
     */
    ProjectConfig.equals = function (projectConfig1, projectConfig2) {
        if (!projectConfig1 || !projectConfig2)
            return false;
        return this.compareEtags(projectConfig1.HttpETag, projectConfig2.HttpETag);
    };
    ProjectConfig.compareEtags = function (etag1, etag2) {
        return this.ensureStrictEtag(etag1) === this.ensureStrictEtag(etag2);
    };
    ProjectConfig.ensureStrictEtag = function (etag) {
        if (!etag) {
            return '';
        }
        if (etag.length > 2 && etag.substr(0, 2).toLocaleUpperCase() === "W/") {
            return etag.substring(2);
        }
        return etag;
    };
    return ProjectConfig;
}());
export { ProjectConfig };
var ConfigFile = /** @class */ (function () {
    function ConfigFile() {
    }
    ConfigFile.Preferences = "p";
    ConfigFile.FeatureFlags = "f";
    return ConfigFile;
}());
export { ConfigFile };
var Preferences = /** @class */ (function () {
    function Preferences() {
    }
    Preferences.BaseUrl = "u";
    Preferences.Redirect = "r";
    return Preferences;
}());
export { Preferences };
var Setting = /** @class */ (function () {
    function Setting(value, rolloutPercentageItems, rolloutRules, variationId) {
        this.value = value;
        this.rolloutPercentageItems = rolloutPercentageItems;
        this.rolloutRules = rolloutRules;
        this.variationId = variationId;
    }
    Setting.fromJson = function (json) {
        var _a, _b, _c, _d;
        return new Setting(json[this.Value], (_b = (_a = json[this.RolloutPercentageItems]) === null || _a === void 0 ? void 0 : _a.map(function (item) { return RolloutPercentageItem.fromJson(item); })) !== null && _b !== void 0 ? _b : [], (_d = (_c = json[this.RolloutRules]) === null || _c === void 0 ? void 0 : _c.map(function (item) { return RolloutRule.fromJson(item); })) !== null && _d !== void 0 ? _d : [], json[this.VariationId]);
    };
    Setting.Value = "v";
    Setting.SettingType = "t";
    Setting.RolloutPercentageItems = "p";
    Setting.RolloutRules = "r";
    Setting.VariationId = "i";
    return Setting;
}());
export { Setting };
var RolloutRule = /** @class */ (function () {
    function RolloutRule(comparisonAttribute, comparator, comparisonValue, value, variationId) {
        this.comparisonAttribute = comparisonAttribute;
        this.comparator = comparator;
        this.comparisonValue = comparisonValue;
        this.value = value;
        this.variationId = variationId;
    }
    RolloutRule.fromJson = function (json) {
        return new RolloutRule(json[this.ComparisonAttribute], json[this.Comparator], json[this.ComparisonValue], json[this.Value], json[this.VariationId]);
    };
    RolloutRule.Order = "o";
    RolloutRule.ComparisonAttribute = "a";
    RolloutRule.Comparator = "t";
    RolloutRule.ComparisonValue = "c";
    RolloutRule.Value = "v";
    RolloutRule.VariationId = "i";
    return RolloutRule;
}());
export { RolloutRule };
var RolloutPercentageItem = /** @class */ (function () {
    function RolloutPercentageItem(percentage, value, variationId) {
        this.percentage = percentage;
        this.value = value;
        this.variationId = variationId;
    }
    RolloutPercentageItem.fromJson = function (json) {
        return new RolloutPercentageItem(json[this.Percentage], json[this.Value], json[this.VariationId]);
    };
    RolloutPercentageItem.Order = "o";
    RolloutPercentageItem.Value = "v";
    RolloutPercentageItem.Percentage = "p";
    RolloutPercentageItem.VariationId = "i";
    return RolloutPercentageItem;
}());
export { RolloutPercentageItem };
